/* eslint-disable prettier/prettier */
import React from "react";
import TugMetricsDetailsV2 from "../../../common/TugMetricsDetailsV2";
import { FRONT_TUG_METRIC_TREND } from "../../../../routes/routerPath";

const TugFrontMetricsDetailsV2 = (props) => (
  <TugMetricsDetailsV2
    {...props}
    reportType="front"
    trendPath={FRONT_TUG_METRIC_TREND}
  />
);
export default TugFrontMetricsDetailsV2;
